module.exports = __webpack_public_path__ + "static/media/08-search.cd6b07c0.png";